import { OrderedSet } from 'immutable';
import isNumber from 'lodash/isNumber';
import { StyleType } from '../util/style';
import { isHTMLElement } from './helpers'; // https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight

var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
var boldTriggerValue = 400;
var notBoldValues = ['light', 'lighter', 'normal', '100', '200', '300', '400'];
var HTMLTagToRawInlineStyle = {
  b: StyleType.BOLD,
  em: StyleType.ITALIC,
  i: StyleType.ITALIC,
  strong: StyleType.BOLD,
  u: StyleType.UNDERLINE,
  sup: StyleType.SUPERSCRIPT
};
/**
 * Try to guess the inline style of an HTML element based on its css
 * styles (font-weight, font-style, vertical-align and text-decoration).
 */

var styleFromNodeAttributes = function styleFromNodeAttributes(node, style) {
  if (!isHTMLElement(node)) {
    return style;
  }

  var htmlElement = node;
  var fontWeight = htmlElement.style.fontWeight;
  var fontStyle = htmlElement.style.fontStyle;
  var textDecoration = htmlElement.style.textDecoration;
  var verticalAlign = htmlElement.style.verticalAlign; // eslint-disable-next-line complexity

  return style.withMutations(function (styleToMutate) {
    if (boldValues.indexOf(fontWeight) >= 0 || isNumber(fontWeight) && fontWeight > boldTriggerValue) {
      styleToMutate.add(StyleType.BOLD);
    } else if (notBoldValues.indexOf(fontWeight) >= 0) {
      styleToMutate.remove(StyleType.BOLD);
    }

    if (fontStyle === 'italic') {
      styleToMutate.add(StyleType.ITALIC);
    } else if (fontStyle === 'normal') {
      styleToMutate.remove(StyleType.ITALIC);
    }

    if (verticalAlign === 'super') {
      styleToMutate.add(StyleType.SUPERSCRIPT);
    }

    if (textDecoration === 'underline') {
      styleToMutate.add(StyleType.UNDERLINE);
    }

    if (textDecoration === 'none') {
      styleToMutate.remove(StyleType.UNDERLINE);
    }
  });
};

export var detectStyle = function detectStyle(node) {
  var nodeName = node.nodeName;
  var style = OrderedSet();
  var tagStyle = HTMLTagToRawInlineStyle[nodeName];

  if (tagStyle) {
    style = style.add(tagStyle);
  }

  style = styleFromNodeAttributes(node, style);
  return style;
};